<template>
  <el-container>
    <el-header>
      <Header chose_index="1"></Header>
    </el-header>
    <el-main>
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="院校属性" name="first">
          <template #label>
            <span><i class="el-icon-school"></i> 院校属性</span>
          </template>
          <el-form ref="form" :model="form" label-width="80px" @submit.native.prevent>
            <el-form-item label="院校省份">
              <el-checkbox-group v-model="form.provinces" @change="province_change($event)">
                <el-checkbox :label="item.province_id" :key="item.id" v-for="item in provinces">{{ item.province }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="院校类型">
              <el-checkbox-group v-model="form.type" @change="type_change($event)">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in educational_type">{{
                    item.name
                  }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="院校层次">
              <el-checkbox-group v-model="form.level" @change="level_change($event)">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in school_level">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="院校性质">
              <el-checkbox-group v-model="form.nature_type" @change="nature_type_change($event)">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in nature_type">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="招生类型">
              <el-checkbox-group v-model="form.recruit_type" @change="recruit_type_change($event)">
                <el-checkbox :label="item.id" :key="item.id" v-for="item in recruit_type">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="意向院校">
              <el-select-v2
                  v-model="form.school_ids"
                  filterable
                  :options="school_list"
                  placeholder="请选择"
                  style="width: 200px;"
                  @change="school_list_change($event)"
                  clearable
                  multiple
              />
            </el-form-item>
            <el-form-item label="筛选条件" style="border: #F2F6FC 1px solid;">
              <el-tag
                  v-for="tag in tags"
                  :key="tag.name"
                  closable
                  @close="tag_click(tag)"
                  :type="tag.type">
                {{ tag.name }}
              </el-tag>
              <el-button type="primary" style="float: right;margin: 6px 5px 0 0;" size="mini" @click="tags_clear"
                         icon="el-icon-delete">
                清空
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="专业属性" name="second">
          <template #label>
            <span><i class="el-icon-reading"></i> 专业属性</span>
          </template>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="专业选择">
              <el-radio-group v-model="form.major_one" @change="major_one_change">
                <el-radio :label="item.id" :key="item.id" v-for="item in major_one"
                          style="margin-top: 10px;margin-bottom: 10px;">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-divider></el-divider>
            <div v-if="majors.length !== 0">
              <el-form-item label="&nbsp;&nbsp;">
                <el-checkbox-group v-model="form.major_two" @change="major_two_change($event)">
                  <el-checkbox :label="item.code" :key="item.id" v-for="item in majors">
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
            </div>
            <el-form-item label="我的关注">
              <el-select-v2
                  v-model="form.follow_major"
                  filterable
                  :options="major_three_list"
                  placeholder="请选择"
                  style="width: 200px;"
                  @change="major_three_list_change($event)"
                  clearable
                  multiple
              />
            </el-form-item>
            <el-form-item label="筛选条件" style="border: #F2F6FC 1px solid;">
              <el-tag
                  v-for="tag in tags"
                  :key="tag.name"
                  closable
                  @close="tag_click(tag)"
                  :type="tag.type">
                {{ tag.name }}
              </el-tag>
              <el-button type="primary" style="float: right" size="mini" @click="tags_clear" icon="el-icon-delete">
                清空
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div style="height: 20px;"></div>
      <el-row>
        <el-col :span="4" :gutter="1" style="display:flex;justify-content: left;align-items: center;">
          <el-button-group>
            <el-button type="primary" id="major_button" @click="major_button_press">专业/院校</el-button>
            <el-button type="primary" id="school_button" @click="school_button_press">院校/专业</el-button>
          </el-button-group>
        </el-col>
        <el-col :span="2" :gutter="1" style="display:flex;justify-content: left;align-items: center;">
          <el-button type="text" icon="el-icon-tickets" @click="dialogFormVisible = true">推荐报告</el-button>
        </el-col>
        <el-col :span="2" :gutter="1" style="display:flex;justify-content: left;align-items: center;">
          <el-button type="danger" size="mini" circle @click="change_status(1)">冲</el-button>
          <el-button type="success" size="mini" circle @click="change_status(2)">稳</el-button>
          <el-button type="info" size="mini" circle @click="change_status(3)">保</el-button>
        </el-col>
        <el-col :span="5" :gutter="1" style="display:flex;justify-content: left;align-items: center;">
          <div style="font-size: 12px;">
            我的成绩: {{ base_info.score }}分 {{ base_info.precedence }}位次 {{ base_info.subjects }}
            <span @click="edit_info_click" style="cursor:pointer"><i class="el-icon-edit"></i></span>
          </div>
        </el-col>
      </el-row>
      <el-table
          row-key="date"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;margin-top: 10px;"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
      >
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="类型"
            width="65">
          <template #default="scope">
            <el-button type="danger" size="mini" v-if="scope.row.match_status === 1">冲</el-button>
            <el-button type="success" size="mini" v-if="scope.row.match_status === 2">稳</el-button>
            <el-button type="info" size="mini" v-if="scope.row.match_status === 3">保</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="图标"
            width="80"
        >
          <template #default="scope">
            <img :src="scope.row.school_logo" style="height: 50px;"/>
          </template>
        </el-table-column>
        <el-table-column
            label="院校"
            style="min-width: 230px;"
        >
          <template #default="scope">
              <span>{{ scope.row.school_name }}[{{ scope.row.nature_str }}]
                (<span style="color: #e6a23c">{{ scope.row.type_str }}</span>)</span>
            <el-tag size="mini" style="margin-left: 3px;" type="warning" v-if="scope.row.postgraduate !== 2">
              {{ scope.row.postgraduate }}
            </el-tag>
            <br>
            <el-tag size="mini">上段位院校变化量:{{ scope.row.use_sum }}</el-tag>
            <el-tag size="mini">本院校变化量:{{ scope.row.diff }}</el-tag>
            <br>
            <el-tag size="mini" v-if="scope.row.postgraduate == 1">免</el-tag>
            <el-tag size="mini" type="success" v-for="(item, index) in scope.row.label_list" :key="index">{{ item }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="majors"
            label="专业"
            v-if="form.search_type === 1"
            width="250">
          <template #default="scope">
            <span>{{ scope.row.majors }}</span>
            <el-tag type="danger" size="mini" v-if="scope.row.new_major === 1">新</el-tag>
            <br>
            <el-tag size="mini" v-if="scope.row.discipline_ranking_major != ''">
              {{ scope.row.discipline_ranking_major }}
            </el-tag>
            <el-tag size="mini" v-if="scope.row.double_first_class_major != ''">
              {{ scope.row.double_first_class_major }}
            </el-tag>
            <el-tag size="mini" v-if="scope.row.major_topic_str != ''">{{ scope.row.major_topic_str }}</el-tag>
            <el-tag size="mini" v-if="scope.row.superiority_str != ''">{{ scope.row.superiority_str }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="address"
            label="招生计划"
            width="150">
          <template #default="scope">
            人数: <b>{{ scope.row.num }}</b><br>
            {{ scope.row.length }}年 ￥{{ scope.row.fees }}<br>
            {{ scope.row.major_group_rule }}<br>
            <span v-if="scope.row.major_limit === 1" style="color: #67c23a">专业匹配</span>
            <span v-else-if="scope.row.major_limit === 0" style="color: red">专业不匹配</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="tag"
            label="统计"
            width="100">
          <el-tooltip class="item" effect="dark" content="录取人数" placement="right">
            <i class="el-icon-user"></i>
          </el-tooltip>
          <br>
          <el-tooltip class="item" effect="dark" content="线差" placement="right">
            <i class="el-icon-data-line"></i>
          </el-tooltip>
          <br>
          <el-tooltip class="item" effect="dark" content="最低分" placement="right">
            <i class="el-icon-medal"></i>
          </el-tooltip>
          <br>
          <el-tooltip class="item" effect="dark" content="最低位次" placement="right">
            <i class="el-icon-sort-down"></i>
          </el-tooltip>
        </el-table-column>
        <el-table-column
            prop="tag"
            :label="before_one"
            width="100"
            filter-placement="bottom-end">
          <template #default="scope">
            <span v-if="scope.row.before_one === '未招生'">/</span>
            <span v-else>
              {{ scope.row.before_one.number_basics }}<br>
              {{ scope.row.before_one.line_diff_basics }}<br>
              {{ scope.row.before_one.low_score_basics }}<br>
              {{ scope.row.before_one.precedence_basics }}<br>
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="tag"
            :label="before_two"
            width="100"
            filter-placement="bottom-end">
          <template #default="scope">
            <span v-if="scope.row.before_two === '未招生'">/</span>
            <span v-else>
                {{ scope.row.before_two.number_basics }}<br>
                {{ scope.row.before_two.line_diff_basics }}<br>
                {{ scope.row.before_two.low_score_basics }}<br>
                {{ scope.row.before_two.precedence_basics }}<br>
              </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="tag"
            :label="before_three"
            width="100"
            filter-placement="bottom-end">
          <template #default="scope">
            <span v-if="scope.row.before_three === '未招生'">/</span>
            <span v-else>
                {{ scope.row.before_three.number_basics }}<br>
                {{ scope.row.before_three.line_diff_basics }}<br>
                {{ scope.row.before_three.low_score_basics }}<br>
                {{ scope.row.before_three.precedence_basics }}<br>
              </span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="100">
          <template #default="scope">
            <el-button
                v-if="form.search_type === 1"
                size="mini"
                type="danger"
                :disabled="scope.row.major_limit === 0"
                @click="favorite(scope.$index, scope.row)">
              <span v-if="scope.row.collection === 1">取消</span>
              <span v-else>收藏</span>
            </el-button>
            <el-button
                v-else
                size="mini"
                type="warning"
                @click="show_majors(scope.$index, scope.row)">查看({{ scope.row.count }})
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="height: 20px;"></div>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-model:currentPage="form.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="form.total">
      </el-pagination>
    </el-main>
  </el-container>
  <el-dialog title="AI智能推荐引擎" v-model="dialogFormVisible" width="50%">
    <div id="myChart" style="margin:0 auto; padding:0;width:600px; height:550px;"></div>
    <template #footer>
    <span class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
    </span>
    </template>
  </el-dialog>
  <EditInfo :show="show_edit_info"></EditInfo>
  <el-dialog title="学校专业列表" v-model="dialogMajorsVisible" width="70%" style="text-align: center">
    <el-table
        row-key="date"
        ref="multipleTable"
        height="500"
        :data="majorsData"
        tooltip-effect="dark"
        style="width: 100%;margin: 0 auto;"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
    >
      <el-table-column
          label="类型"
          width="180">
        <template #default="scope">
          <el-button type="danger" size="mini" v-if="scope.row.match_status === 1">冲</el-button>
          <el-button type="success" size="mini" v-if="scope.row.match_status === 2">稳</el-button>
          <el-button type="info" size="mini" v-if="scope.row.match_status === 3">保</el-button>
          <el-button type="warning" size="mini" v-if="scope.row.new_major === 1">新</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="majors"
          label="专业"
          width="350">
        <template #default="scope">
          <span>{{ scope.row.majors }}</span>
          <el-tag type="danger" size="mini" v-if="scope.row.new_major === 1">新</el-tag>
          <br>
          <el-tag size="mini" v-if="scope.row.discipline_ranking_major != ''">
            {{ scope.row.discipline_ranking_major }}
          </el-tag>
          <el-tag size="mini" v-if="scope.row.double_first_class_major != ''">
            {{ scope.row.double_first_class_major }}
          </el-tag>
          <el-tag size="mini" v-if="scope.row.major_topic_str != ''">{{ scope.row.major_topic_str }}</el-tag>
          <el-tag size="mini" v-if="scope.row.superiority_str != ''">{{ scope.row.superiority_str }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="address"
          label="招生计划"
          width="150">
        <template #default="scope">
          人数: <b>{{ scope.row.num }}</b><br>
          {{ scope.row.length }}年 ￥{{ scope.row.fees }}<br>
          {{ scope.row.major_group_rule }}<br>
          <span v-if="scope.row.major_limit === 1" style="color: #67c23a">专业匹配</span>
          <span v-else-if="scope.row.major_limit === 0" style="color: red">专业不匹配</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="tag"
          label="统计"
          width="100">
        <el-tooltip class="item" effect="dark" content="录取人数" placement="right">
          <i class="el-icon-user"></i>
        </el-tooltip>
        <br>
        <el-tooltip class="item" effect="dark" content="线差" placement="right">
          <i class="el-icon-data-line"></i>
        </el-tooltip>
        <br>
        <el-tooltip class="item" effect="dark" content="最低分" placement="right">
          <i class="el-icon-medal"></i>
        </el-tooltip>
        <br>
        <el-tooltip class="item" effect="dark" content="最低位次" placement="right">
          <i class="el-icon-sort-down"></i>
        </el-tooltip>
      </el-table-column>
      <el-table-column
          prop="tag"
          :label="before_one"
          width="150"
          filter-placement="bottom-end">
        <template #default="scope">
          <span v-if="scope.row.before_one === '未招生'">/</span>
          <span v-else>
                {{ scope.row.before_one.number_basics }}<br>
                {{ scope.row.before_one.line_diff_basics }}<br>
                {{ scope.row.before_one.low_score_basics }}<br>
                {{ scope.row.before_one.precedence_basics }}<br>
              </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="tag"
          :label="before_two"
          width="150"
          filter-placement="bottom-end">
        <template #default="scope">
          <span v-if="scope.row.before_two === '未招生'">/</span>
          <span v-else>
                {{ scope.row.before_two.number_basics }}<br>
                {{ scope.row.before_two.line_diff_basics }}<br>
                {{ scope.row.before_two.low_score_basics }}<br>
                {{ scope.row.before_two.precedence_basics }}<br>
              </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="tag"
          :label="before_three"
          width="150"
          filter-placement="bottom-end">
        <template #default="scope">
          <span v-if="scope.row.before_three === '未招生'">/</span>
          <span v-else>
                {{ scope.row.before_three.number_basics }}<br>
                {{ scope.row.before_three.line_diff_basics }}<br>
                {{ scope.row.before_three.low_score_basics }}<br>
                {{ scope.row.before_three.precedence_basics }}<br>
              </span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="100">
        <template #default="scope">
          <el-button
              v-if="scope.row.collection === 0"
              size="mini"
              type="danger"
              :disabled="scope.row.major_limit === 0"
              @click="favorite(scope.$index, scope.row, 2)">收藏
          </el-button>
          <el-button
              v-if="scope.row.collection === 1"
              size="mini"
              type="danger"
              @click="un_favorite(scope.$index, scope.row, 2)">取消收藏
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
    <span class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
    </span>
    </template>
  </el-dialog>
</template>

<script>
import Sortable from 'sortablejs'
import http from '@/utils/http'
import api from '@/api'
import Header from '@/components/Header.vue'

import * as echarts from 'echarts';
import {onMounted} from "vue";
import EditInfo from "../components/EditInfo";

export default {
  name: 'ChoseCollege',
  components: {EditInfo, Header},
  data() {
    return {
      show_edit_info: 0, // 显示编辑个人信息对话框
      marks: [],
      score: 0,
      all_num: 0,
      top: 0,
      top_num: 0,
      middle_num: 0,
      bottom_num: 0,
      bottom: 0,
      label_num: [],
      dialogVisible: false,
      dialogMajorsVisible: false,
      activeName: 'first',
      listName: 'first',
      tags: {},
      form: {
        provinces: [],
        type: [],
        level: [],
        recruit_type: [],
        nature_type: [],
        school_ids: [],
        follow_major: [],
        major_one: 0,
        major_two: [],
        page_size: 10,
        total: 0,
        page: 1,
        search_type: 1,
        score_range: 0,
      },
      majorsData: [],
      formLabelWidth: '120px',
      dialogFormVisible: true,
      provinces: [],
      types: [],
      schools: [],
      major_one: [],
      major_two: [],
      major_three: [],
      major_three_list: [],
      majors: [],
      school_list: [],
      level: [],
      educational_type: [],
      nature_type: [],
      recruit_type: [],
      school_level: [],
      tableData: [],
      before_one: '',
      before_two: '',
      before_three: '',
      base_info: [],
      //
      old_nature_type: [],
      old_recruit_type: [],
      old_educational_type: [],
      old_school_level: [],
      old_provinces: [],
      old_school_list: [],
      old_follow_major: [],
      old_major_two: [],
    };
  },
  mounted() {
    this.before_one = (new Date()).getFullYear() - 1 + ''
    this.before_two = this.before_one - 1 + ''
    this.before_three = this.before_one - 2 + ''

    document.getElementById('major_button').style.backgroundColor = "#67c23a"
    document.getElementById('major_button').style.borderColor = "#67c23a"

    this.rowDrop()
    //
    this.dialogFormVisible = false;
    this.collect()
  },
  created() {
    this.base_info = JSON.parse(localStorage.getItem('base_info'))

    this.schoolAreas()
    this.schoolLabel()
    this.school()
    this.majorCode()
    this.change()
  },
  methods: {
    edit_info_click() {
      this.show_edit_info++
    },
    favorite(index, list, type = 1) {
      console.log(index)
      if (list.collection === 1) {
        this.un_favorite(index, list, type)
      } else {
        let data = http.post(api.user.favorite, {"favorite_id": list.id})
        data.then(data => {
          console.log(data)
          console.log(data.data)
          if (data.code === 10000) {
            if (type === 1) {
              this.tableData[index]['collection'] = 1
            } else {
              this.majorsData[index]['collection'] = 1
            }
            this.$notify({
              title: '成功',
              message: '收藏成功',
              type: 'success'
            });
          } else {
            this.$notify.error({
              title: '错误',
              message: data.data.msg
            });
          }
        })
      }
      console.log(list.id)
    },
    un_favorite(index, list, type = 1) {
      console.log(list.id)
      let data = http.post(api.user.un_favorite, {"favorite_id": list.id})
      data.then(data => {
        console.log(data)
        console.log(data.data)
        if (data.code === 10000) {
          if (type === 1) {
            this.tableData[index]['collection'] = 1
          } else {
            this.majorsData[index]['collection'] = 1
          }
          this.$notify({
            title: '成功',
            message: '取消收藏成功',
            type: 'success'
          });
        } else {
          this.$notify.error({
            title: '错误',
            message: data.data.msg
          });
        }
      })
    },
    show_majors(index, row) {
      this.majorsData = []
      this.dialogMajorsVisible = true;
      let param = this.form;
      param['school_id'] = row.school_id
      param['page'] = 1
      let count = row.count > 10 ? row.count : 10;
      param['page_size'] = count
      let data = http.post(api.match.majors, param)
      data.then(data => {
        this.majorsData = data.data.data
      })
    },
    tags_clear() {
      this.tags = []
    },
    tag_click(tag) {
      console.log(tag)
      console.log(this.form)
      delete this.tags[tag['type']]

      let index = -1
      switch (tag['class']) {
        case 'provinces':
          index = this.form.provinces.indexOf(tag['type'])
          if (index > -1) {
            this.form.provinces.splice(index, 1);
          }
          break;
        case 'educational_type':
          index = this.form.type.indexOf(tag['type'])
          if (index > -1) {
            this.form.type.splice(index, 1);
          }
          break;
        case 'school_level':
          index = this.form.level.indexOf(tag['type'])
          if (index > -1) {
            this.form.level.splice(index, 1);
          }
          break;
        case 'major_two':
          index = this.form.major_two.indexOf(tag['type'])
          if (index > -1) {
            this.form.major_two.splice(index, 1);
          }
          break;
        case 'major_three':
          index = this.form.follow_major.indexOf(tag['type'])
          if (index > -1) {
            this.form.follow_major.splice(index, 1);
          }
          break;
        case 'school_list':
          index = this.form.school_ids.indexOf(tag['type'])
          if (index > -1) {
            this.form.school_ids.splice(index, 1);
          }
          break;
        case 'nature_type':
          index = this.form.nature_type.indexOf(tag['type'])
          if (index > -1) {
            this.form.nature_type.splice(index, 1);
          }
          break;
        case 'recruit_type':
          index = this.form.recruit_type.indexOf(tag['type'])
          if (index > -1) {
            this.form.recruit_type.splice(index, 1);
          }
          break;
        default:
          console.log(tag)
          break
      }

      this.change()
    },
    province_change(e) {
      console.log(e)
      let new_obj = e.concat(this.old_provinces).filter(v => e.includes(v) && !this.old_provinces.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        this.tags[new_index] = {
          name: this.provinces[new_index]['province'],
          type: this.provinces[new_index]['province_id'],
          class: 'provinces'
        }
      }

      let del_obj = this.old_provinces.concat(e).filter(v => !e.includes(v) && this.old_provinces.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_provinces = e

      this.change()
    },
    type_change(e) {
      //console.log(e)
      let new_obj = e.concat(this.old_educational_type).filter(v => e.includes(v) && !this.old_educational_type.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        this.tags[new_index] = {
          name: this.educational_type[new_index]['name'],
          type: this.educational_type[new_index]['id'],
          class: 'educational_type'
        }
      }

      let del_obj = this.old_educational_type.concat(e).filter(v => !e.includes(v) && this.old_educational_type.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_educational_type = e

      this.change()
    },
    nature_type_change(e) {
      //console.log(e)
      let new_obj = e.concat(this.old_nature_type).filter(v => e.includes(v) && !this.old_nature_type.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        this.tags[new_index] = {
          name: this.nature_type[new_index]['name'],
          type: this.nature_type[new_index]['id'],
          class: 'nature_type'
        }
      }

      let del_obj = this.old_nature_type.concat(e).filter(v => !e.includes(v) && this.old_nature_type.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_nature_type = e

      this.change()
    },
    recruit_type_change(e) {
      let new_obj = e.concat(this.old_recruit_type).filter(v => e.includes(v) && !this.old_recruit_type.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        this.tags[new_index] = {
          name: this.recruit_type[new_index]['name'],
          type: this.recruit_type[new_index]['id'],
          class: 'recruit_type'
        }
      }

      let del_obj = this.old_recruit_type.concat(e).filter(v => !e.includes(v) && this.old_recruit_type.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_recruit_type = e

      this.change()
    },
    level_change(e) {
      let new_obj = e.concat(this.old_school_level).filter(v => e.includes(v) && !this.old_school_level.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        this.tags[new_index] = {
          name: this.school_level[new_index]['name'],
          type: this.school_level[new_index]['id'],
          class: 'school_level'
        }
      }

      let del_obj = this.old_school_level.concat(e).filter(v => !e.includes(v) && this.old_school_level.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_school_level = e

      this.change()
    },
    major_two_change(e) {
      console.log(e)
      let new_obj = e.concat(this.old_major_two).filter(v => e.includes(v) && !this.old_major_two.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        for (let i in this.major_two[this.form.major_one]) {
          if (new_index == this.major_two[this.form.major_one][i]['code']) {
            this.tags[new_index] = {
              name: this.major_two[this.form.major_one][i]['name'],
              type: this.major_two[this.form.major_one][i]['code'],
              class: 'major_two'
            }
          }
        }
      }

      let del_obj = this.old_major_two.concat(e).filter(v => !e.includes(v) && this.old_major_two.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_major_two = e

      this.change()
    },
    major_three_list_change(e) {
      // console.log(e)
      let new_obj = e.concat(this.old_follow_major).filter(v => e.includes(v) && !this.old_follow_major.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        for (let i in this.major_three_list) {
          if (new_index == this.major_three_list[i]['value']) {
            this.tags[new_index] = {
              name: this.major_three_list[i]['label'],
              type: this.major_three_list[i]['value'],
              class: 'major_three'
            }
          }
        }
      }

      let del_obj = this.old_follow_major.concat(e).filter(v => !e.includes(v) && this.old_follow_major.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_follow_major = e

      this.change()
    },
    school_list_change(e) {
      //console.log(e)
      let new_obj = e.concat(this.old_school_list).filter(v => e.includes(v) && !this.old_school_list.includes(v))
      if (new_obj.length > 0) {
        let new_index = new_obj[0]
        for (let i in this.school_list) {
          if (new_index == this.school_list[i]['value']) {
            this.tags[new_index] = {
              name: this.school_list[i]['label'],
              type: this.school_list[i]['value'],
              class: 'school_list'
            }
          }
        }
      }

      let del_obj = this.old_school_list.concat(e).filter(v => !e.includes(v) && this.old_school_list.includes(v))
      if (del_obj.length > 0) {
        let del_index = del_obj[0]
        delete this.tags[del_index]
      }

      this.old_school_list = e

      this.change()
    },
    change_status(val) {
      this.form.score_range = val
      this.change()
    },
    change() {
      let obj = {...this.form}
      let data = http.post(api.match.list, obj)
      data.then(data => {
        console.log(data)
        this.tableData = data.data.data
        for (let i in this.tableData) {
          if (this.tableData[i]['before_one'] !== '未招生') {
            this.tableData[i]['before_one'] = JSON.parse(this.tableData[i]['before_one'])
          }
          if (this.tableData[i]['before_two'] !== '未招生') {
            this.tableData[i]['before_two'] = JSON.parse(this.tableData[i]['before_two'])
          }
          if (this.tableData[i]['before_three'] !== '未招生') {
            this.tableData[i]['before_three'] = JSON.parse(this.tableData[i]['before_three'])
          }
        }
        this.form.page = data.data.current_page
        this.form.total = data.data.total
        this.form.page_size = data.data.per_page
      })
    },
    major_one_change(e) {
      this.majors = this.major_two[e] || []
    },
    school_input_change(event) {
      console.log(this.form.school_ids)
    },
    handleSizeChange(val) {
      this.form.page_size = val
      this.form.page = 1
      this.change()
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.change()
      console.log(`当前页: ${val}`);
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd({newIndex, oldIndex}) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    listHandleClick(tab, event) {
      //console.log(tab, event);
      if (tab.props.name === '') {
        return false;
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    schoolAreas() {
      let data = http.get(api.school.area, {})
      data.then(data => {
        this.provinces = data.data
      })
    },
    schoolLabel() {
      let data = http.get(api.school.label, {})
      data.then(data => {
        console.log(data.data)
        this.educational_type = data.data.educational_type
        this.nature_type = data.data.nature_type
        this.recruit_type = data.data.recruit_type
        this.school_level = data.data.school_level
        this.level = data.data.school_level
        this.types = data.data.recruit_type
      })
    },
    schoolType() {
      let data = http.get(api.school.type, {})
      data.then(data => {
        this.types = data.data
      })
    },
    schoolLevel() {
      let that = this
      let data = http.get(api.school.level, {})
      data.then(data => {
        that.level = data.data
      })
    },
    school() {
      let that = this
      let data = http.get(api.school.list, {})
      data.then(data => {
        that.schools = data.data
        that.school_list = Array.from({length: that.schools.length}).map((_, idx) => ({
          value: `${that.schools[idx]['id']}`,
          label: `${that.schools[idx]['name']}`,
        }))
      })
    },
    majorCode() {
      let that = this
      let data = http.get(api.major.list, {})
      data.then(data => {
        that.major_one = data.data.level_one
        that.major_two = data.data.level_two
        that.major_three = data.data.level_three
        that.major_three_list = Array.from({length: that.major_three.length}).map((_, idx) => ({
          key: `${that.major_three[idx]['id']}`,
          value: `${that.major_three[idx]['code']}`,
          label: `${that.major_three[idx]['name']}`,
        }))
      })
    },
    collect() {
      let data = http.get(api.algorithm.collect, {})
      data.then(data => {
        this.score = data.data.score
        this.all_num = data.data.all_num
        this.top_num = data.data.top_num
        this.top = data.data.top
        this.middle_num = data.data.middle_num
        this.bottom_num = data.data.bottom_num
        this.bottom = data.data.bottom
        this.label_num = data.data.label_num

        let score = data.data.score
        let top = data.data.top
        let bottom = data.data.bottom

        this.marks = {
          top: top + '',
          score: {
            style: {
              color: '#1989FA'
            },
            label: score + ''
          },
          bottom: bottom + '',
        }

        let legend_data = Object.keys(this.label_num);
        let series_data = [
          {value: this.top_num, name: '冲刺'},
          {value: this.middle_num, name: '稳妥', selected: true},
          {value: this.bottom_num, name: '保底'}
        ]
        let info = []
        for (let i in this.label_num) {
          info.push({'name': i, 'value': this.label_num[i]})
        }

        let label_num_data = info
        let dom = document.getElementById('myChart')

        if (dom != null) {
          let myChart = echarts.init(dom);
          // 绘制图表
          myChart.setOption({
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              data: legend_data
            },
            series: [
              {
                name: '统计',
                type: 'pie',
                selectedMode: 'single',
                radius: [0, '30%'],
                label: {
                  formatter: '{b}: {c}',
                  position: 'inner',
                  fontSize: 14,
                },
                labelLine: {
                  show: false
                },
                data: series_data
              },
              {
                name: '学校数量',
                type: 'pie',
                radius: ['45%', '60%'],
                labelLine: {
                  length: 30,
                },
                label: {
                  formatter: ' {b|{b}}:{c} ',
                  backgroundColor: '#F6F8FC',
                  borderColor: '#8C8D8E',
                  borderWidth: 1,
                  borderRadius: 4,

                  rich: {
                    a: {
                      color: '#6E7079',
                      lineHeight: 22,
                      align: 'center'
                    },
                    hr: {
                      borderColor: '#8C8D8E',
                      width: '100%',
                      borderWidth: 1,
                      height: 0
                    },
                    b: {
                      color: '#4C5058',
                      fontSize: 14,
                      fontWeight: 'bold',
                      lineHeight: 33
                    },
                    per: {
                      color: '#fff',
                      backgroundColor: '#4C5058',
                      padding: [3, 4],
                      borderRadius: 4
                    }
                  }
                },
                data: label_num_data
              }
            ]
          });
          window.onresize = () => {
            myChart.resize()
          }
        }
      })
    },
    school_button_press(e) {
      this.form.search_type = 2

      document.getElementById('school_button').style.backgroundColor = "#67c23a"
      document.getElementById('school_button').style.borderColor = "#67c23a"

      document.getElementById('major_button').style.backgroundColor = "#409eff"
      document.getElementById('major_button').style.borderColor = "#409eff"

      this.change()
    },
    major_button_press(e) {
      this.form.search_type = 1

      document.getElementById('major_button').style.backgroundColor = "#67c23a"
      document.getElementById('major_button').style.borderColor = "#67c23a"

      document.getElementById('school_button').style.backgroundColor = "#409eff"
      document.getElementById('school_button').style.borderColor = "#409eff"

      this.change()
    }
  }
}
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-container {
  height: 100%;
  padding: 0;
  margin: 0 auto;
  width: 80%;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.el-dialog__body {
  padding: 0;
}
</style>
